var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF5848",
    d: "M7.333 11H2V9h5.333V7l3.2 3-3.2 3zM18 3v13l-6.4 3v-3H5.2v-4h1.067v3H11.6V6l4.267-2h-9.6v4H5.2V3z",
    className: "icon_svg__black"
  })));
};
export default SvgIcon;